/**
 * @fileoverview A shared component to display the list of available languages in the language picker menu
 * To be used in TopNavigation as well as ResponsiveNavigation
 */
import React from "react";

import { useFeatureOn } from "@services/useFeatureOn";
import { useI18nLocale } from "@services/useI18nLocale";

import { localeToLanguageMap, locales } from "../../../locales";
import { LanguageActionLink, RestyledIcon } from "./LanguagePickerMenuItems.style";

export const LanguagePickerMenuItems = () => {
  const currentLocale = useI18nLocale();
  const featureOn = useFeatureOn();
  const hrefs = Object.fromEntries(
    locales.map((locale) => {
      const url = new URL(window.location.href);
      url.searchParams.set("locale", locale);
      return [locale, url.href];
    })
  );
  return (
    <>
      {Object.entries(localeToLanguageMap)
        .filter(([, { featureFlipper }]) => {
          if (!featureFlipper) {
            /// this language is globally available
            return true;
          }
          return featureOn(featureFlipper);
        })
        .map(([locale, { localizedName: label }]) => {
          return (
            <LanguageActionLink href={hrefs[locale]} active={currentLocale === locale} key={locale} lang={locale}>
              {label}
              {currentLocale === locale && <RestyledIcon name="check" size="1x" data-selected-locale={locale} />}
            </LanguageActionLink>
          );
        })}
    </>
  );
};
